import { render, staticRenderFns } from "./BaseTablePagination.vue?vue&type=template&id=2d6aa915&"
import script from "./BaseTablePagination.vue?vue&type=script&lang=js&"
export * from "./BaseTablePagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports